import './App.css';
import {useEffect} from "react";
import {useTelegram} from "./hooks/useTelegram";
import Header from "./components/Header/Header";
import {Route, Routes} from 'react-router-dom'
import ProductList from "./components/ProductList/ProductList";
import Form from "./components/Form/Form";
import Cash from "./components/Cash/Cash";
import Users from "./components/Users/Users";
import SendItem from "./components/SendItem/SendItem";
import ProcessHash from "./components/ProcessHash/ProcessHash";
import "react-widgets/scss/styles.scss";

function App() {
    const {onToggleButton, tg} = useTelegram();

    useEffect(() => {
        tg.ready();
    }, [])

    return (
        <div className="App">
            <Header />
            <Routes>
                <Route index element={<ProductList />}/>
                <Route path={'form'} element={<Form />}/>
                <Route path={'cash'} element={<Cash />}/>
                <Route path={'users'} element={<Users />}/>
                <Route path={'sendItem'} element={<SendItem />}/>
                <Route path={'processHash'} element={<ProcessHash />}/>
            </Routes>
        </div>
    );
}

export default App;
